import {

  postAddCutomScripts

} from "../../services/apis";

export const attachMasterSlide = (elem, appData, editor, currentSlideRef, linkValue) => {

  function isIPad() {
    return navigator.maxTouchPoints > 1 && 
    /MacIntel|Mac/.test(navigator.userAgent);
  } 

  let slideId = elem.getAttributes();
  //if (currentSlideRef.)
  let checkPopup = false || linkValue === null ? true : false;
  currentSlideRef.current.master.children.forEach(chlid => {
    if (chlid.slideid._id === slideId["data-slide-id"]) {
      checkPopup = true;
    }

  })
  if (!checkPopup) {

    elem.addAttributes({ masterID: elem.attributes.attributes.id });


    if (slideId["ccid"])
      elem.removeAttributes("ccid");

    let masterIDlist = editor.getWrapper().find(`[masterid]`);
    let string = "";
    masterIDlist.forEach((node) => {
      string += `
      $("#${node.attributes.attributes.id}").on('click', function(event){
        let btnId = $(this).attr('data-slide-id')
        btnArray.map((btnObj)=>{
          if(btnObj._id===btnId){
            if(window.location.pathname.indexOf("/preview/") !== -1){
              window.parent.postMessage(
                JSON.stringify({
                  action: "changeIframeSrc",
                  src: btnObj.name,
                  id: btnObj._id,
                  }),
                "*" // parent domain
              );
            }else{
              com.veeva.clm.runAPIRequest("veeva:gotoSlide("+btnObj.name+".zip)"); 
            }
          }
        })
      })`


    })
    if (string !== "") {
      const ID = JSON.stringify(currentSlideRef?.current?.child) === "{}"
        ? currentSlideRef?.current?.master?.slideid?._id
        : currentSlideRef?.current?.child?.slideid?._id;
      let finalString = `$(document).ready(function () { ${string} });`
      postAddCutomScripts(
        { navigationScript: finalString },
        appData.deckId._id,
        ID,
        (res, err) => {
          if (err) {
          } else {
            // console.log(res)
          }
        }
      );
    }
  } else {

    if (slideId["masterID"])
      elem.removeAttributes("masterID");
    return checkPopup
  }

}